import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { OrgsListBase } from "./";

interface OrgsListSyncedProps {
  selectedId: string | null;
  searchQuery: string;
  orgs: readonly AxleOrgSyncOrgFragment[];
  loading: boolean;
  onSync: (org: AxleOrgSyncOrgFragment) => void;
}

export const OrgsListSynced = (props: OrgsListSyncedProps) => {
  return (
    <OrgsListBase
      {...props}
      title="Synced Orgs"
      columnMode={"Sync"}
      filterOrg={({ isLinked, hasSearchQueryMatch }) => hasSearchQueryMatch && isLinked}
    />
  );
};
